import {
  SET_ISTABLET,
  CLEAR_ISTABLET,
  SET_NO_SKIP_COUNT,
  CLEAR_NO_SKIP_COUNT
} from "../actions/type";

// Load initial state from sessionStorage
const loadIsTablet = () => {
  try {
    const savedIsTablet = sessionStorage.getItem("isTablet");
    return savedIsTablet === "true";
  } catch (e) {
    return false;
  }
};

const INIT_STATE = {
  isTablet: loadIsTablet(),
  noSkipCount: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SET_ISTABLET:
      // Persist to sessionStorage
      try {
        sessionStorage.setItem("isTablet", String(payload));
      } catch (e) {
        console.error("Failed to save isTablet to sessionStorage:", e);
      }
      return { ...state, isTablet: payload };
    case CLEAR_ISTABLET:
      // Clear from sessionStorage
      try {
        sessionStorage.removeItem("isTablet");
      } catch (e) {
        console.error("Failed to clear isTablet from sessionStorage:", e);
      }
      return { ...INIT_STATE };
    case SET_NO_SKIP_COUNT:
      return { ...state, noSkipCount: payload };
    case CLEAR_NO_SKIP_COUNT:
      return { ...state, noSkipCount: false };

    default:
      return state;
  }
};
